module.exports = __webpack_public_path__ + "img/christian-viqueira.bcab2d81.jpg";